export const Permission = {
    OWNER: 1 << 0,
    ADMIN: 1 << 1,
    MEMBER: 1 << 2,
    AUTHOR: 1 << 3,
};

export const Status = {
    OPEN: 1,
    CLOSE: 2,
};
